/* tslint:disable */
/* eslint-disable */
/**
 * Portfolio-tracker
 * Portfolio-tracker
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface PersonalAssetOverviewDto
 */
export interface PersonalAssetOverviewDto {
    /**
     * 
     * @type {Date}
     * @memberof PersonalAssetOverviewDto
     */
    startDate: Date;
    /**
     * 
     * @type {number}
     * @memberof PersonalAssetOverviewDto
     */
    cashSum: number;
    /**
     * 
     * @type {number}
     * @memberof PersonalAssetOverviewDto
     */
    valueSum: number;
    /**
     * 
     * @type {number}
     * @memberof PersonalAssetOverviewDto
     */
    assetsCount: number;
    /**
     * 
     * @type {string}
     * @memberof PersonalAssetOverviewDto
     */
    portfolioId: string;
    /**
     * 
     * @type {string}
     * @memberof PersonalAssetOverviewDto
     */
    currencyCode: string;
}

export function PersonalAssetOverviewDtoFromJSON(json: any): PersonalAssetOverviewDto {
    return PersonalAssetOverviewDtoFromJSONTyped(json, false);
}

export function PersonalAssetOverviewDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): PersonalAssetOverviewDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'startDate': (new Date(json['startDate'])),
        'cashSum': json['cashSum'],
        'valueSum': json['valueSum'],
        'assetsCount': json['assetsCount'],
        'portfolioId': json['portfolioId'],
        'currencyCode': json['currencyCode'],
    };
}

export function PersonalAssetOverviewDtoToJSON(value?: PersonalAssetOverviewDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'startDate': (value.startDate.toISOString()),
        'cashSum': value.cashSum,
        'valueSum': value.valueSum,
        'assetsCount': value.assetsCount,
        'portfolioId': value.portfolioId,
        'currencyCode': value.currencyCode,
    };
}

